import { TFunction } from 'i18next';

import { FormValues } from '../components/VirtualTerminal';
import { validate, validateRequired, validatePhoneNumber, validateEmail } from '../../../helpers/validation';
import { detailedItemsValidation } from '../components/DetailedItems';

export const validateValues = (values: FormValues, t: TFunction) => {
    let errors: { [key: string]: string } = {};
    const manipulatedValues = {
        ...values,
        phoneNumber: values.phoneNumber ? `${values.countryPrefix} ${values.phoneNumber}` : '',
    };

    const validators: { path: string; validator: (value: any) => string | undefined }[] = [
        {
            path: 'payments',
            validator: validateRequired(
                t('payments.virtual_terminal.validation.required', {
                    fieldName: t('payments.virtual_terminal.fields.payment_provider'),
                })
            ),
        },
        {
            path: 'items',
            validator: validateRequired(
                t('payments.virtual_terminal.validation.required', {
                    fieldName: t('payments.virtual_terminal.fields.item'),
                })
            ),
        },
        {
            path: 'merchantReference',
            validator: validateRequired(
                t('payments.virtual_terminal.validation.required', {
                    fieldName: t('payments.virtual_terminal.fields.merchant_reference'),
                    interpolation: { escapeValue: false },
                })
            ),
        },
    ];

    validators.push(...detailedItemsValidation(values.items, t));

    if (values.sendBy === 'sms') {
        validators.push(
            ...[
                {
                    path: 'phoneNumber',
                    validator: validateRequired(
                        t('payments.virtual_terminal.validation.required', {
                            fieldName: t('payments.virtual_terminal.fields.phone_number'),
                        })
                    ),
                },
                {
                    path: 'phoneNumber',
                    validator: validatePhoneNumber(
                        t('payments.virtual_terminal.validation.invalid', {
                            fieldName: t('payments.virtual_terminal.fields.phone_number'),
                        })
                    ),
                },
            ]
        );
    }

    if (values.sendBy === 'email') {
        validators.push(
            ...[
                {
                    path: 'email',
                    validator: validateRequired(
                        t('payments.virtual_terminal.validation.required', {
                            fieldName: t('payments.virtual_terminal.fields.email'),
                        })
                    ),
                },
                {
                    path: 'email',
                    validator: validateEmail(
                        t('payments.virtual_terminal.validation.invalid', {
                            fieldName: t('payments.virtual_terminal.fields.email'),
                        })
                    ),
                },
            ]
        );
    }

    errors = validators.reduce((acc, elem) => {
        return validate(elem.path, elem.validator, manipulatedValues, acc);
    }, errors);

    return errors;
};
